import { render, staticRenderFns } from "./claim_list.vue?vue&type=template&id=2a99985c&scoped=true&"
import script from "./claim_list.vue?vue&type=script&lang=js&"
export * from "./claim_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a99985c",
  null
  
)

export default component.exports